import React from "react";
import Header from "../Components/Header/Header";
import ButtonList from "../Components/ButtonList/ButtonList";
import GoogleMapComponent from "../Components/Map/Map";
import ContactUs from "../Components/ContactUs/ContactUs";
import Footer from "../Components/Footer/Footer";

function GolfStore() {
    return (
        <>
            <Header />

            <section id="hero" className="hero img_bg page-section">
                <div className="iframe-hero">
                    <iframe src="https://player.vimeo.com/video/562011685?autoplay=1&controls=0&loop=1&muted=1" frameBorder={0} allowFullScreen />
                </div>
                <div className="container-xl">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="hero_content">
                                <h1 className="hide_mobile">
                                    Foreward golf clubs <br /> are designed with <br />zero gimmicks.
                                </h1>
                                <h2>
                                    <span className="hide_mobile">Our golf clubs were created out of a necessity not just to make a profit. We saw a void in the industry and took it upon ourselves to fix it.</span>
                                </h2>
                                <h1 className="show_mobile">
                                    Designed with <br /> zero gimmicks.
                                </h1>
                                <h2>
                                    <span className="show_mobile">
                                        Created out of a necessity not just to make a profit. We saw a void in the industry and took it upon ourselves to fix it.
                                    </span>
                                </h2>
                                <div className="arrow_animation show_mobile bounce pt-3">
                                    <i className="bi bi-arrow-down-short" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Golf Store section start here  */}

            <section id="our_process" className="our_process bg_dark page-section bg_img">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <h2 className="sec_title">Our Store:</h2>
                        <div className="btn-section hide_mobile">
                            <ButtonList />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">  
                            <GoogleMapComponent />
                        </div>
                        <div className="col-lg-4">
                            <div className="gs_b mb-3">
                                <div className="gab_text mb-3"><h5>Golf Store Location</h5></div>
                                <span className="c_action_link d-block mb-2">5917 Olivas Park Dr. Suite A Ventura, California 93003</span>
                            </div>
                            <div className="gs_b mb-3">
                                <div className="gab_text mb-3"><h5>Golf Store Location</h5></div>
                                <span className="c_action_link d-block mb-2">5917 Olivas Park Dr. Suite A Ventura, California 93003</span>
                            </div>
                            <div className="gs_b">
                                <div className="gab_text mb-3"><h5>Golf Store Location</h5></div>
                                <span className="c_action_link d-block mb-2">5917 Olivas Park Dr. Suite A Ventura, California 93003</span>
                            </div>
                        </div>
                    </div>

                    <div className="btn-section hide_desktop-v2 mt-5">
                        <ButtonList />
                    </div>
                </div>
            </section>

            <ContactUs />
            <Footer />
        </>
    )
}

export default GolfStore;